import { ENDPOINTS } from '@philips-emr/hpms-health-insurance-commons';
import { ToastLevel } from '@philips-emr/tws-constants';
import { HttpService, MessageService, ModalService } from '@philips-emr/tws-core/lib/services';

import { ToastService } from './toast-service';

interface Term {
  dsTerm: string,
  nrSequence: number,
  type: string,
}

const USE_TERM = 'TU';
export default class TermsService {

  public static openTermModal(term: Term): void {
    let title = '';
    if (term) {
      title = term.type == USE_TERM ? MessageService.translate('hi.terms-of-service')
        : MessageService.translate('hi.privacy-notice');
      ModalService.openDefault({
        id: 'term-modal',
        closeable: false,
        fragment: 'assing-term',
        title: title,
        contextData: { type: term.type },
      });
    }
  }

  public static checkTerms(): void {
    HttpService.get<Term[]>(ENDPOINTS.GET.TERMS).then((response) => {
      const terms = response.body;

      if (terms && terms.length > 0) {
        const term = terms.pop();
        if (term) {
          this.openTermModal(term);
        }
      }
    }).catch(() => ToastService.open({ message: MessageService.translate('hi.general-error'), level: ToastLevel.ERROR }));
  }

}

export type {
  Term,
};
